import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
export function TermsOfServicePage() {
  return <>
      <Helmet data-id="element-9962" data-mp="14xpib04bdstu">
        <title data-id="element-9963" data-mp="14x7oea54jqp3">Terms of Service | ToxicDetector</title>
        <meta name="description" content="Read the terms and conditions for using ToxicDetector's AI-powered message analysis tools." data-id="element-9964" data-mp="150279x8hp3ge" />
        <link rel="canonical" href="https://toxicdetector.com/terms" data-id="element-9965" data-mp="vy2r175au3ei" />
        <meta property="og:title" content="Terms of Service | ToxicDetector" data-id="element-9966" data-mp="r62i4p79405s" />
        <meta property="og:description" content="Read the terms and conditions for using ToxicDetector's AI-powered message analysis tools." data-id="element-9967" data-mp="m7hjuvbk7qjz" />
        <meta property="og:url" content="https://toxicdetector.com/terms" data-id="element-9968" data-mp="ha7vzk3tjmy9" />
        <meta property="og:type" content="website" data-id="element-9969" data-mp="d5i19ykwceex" />
        <meta name="robots" content="index, follow" data-id="element-9970" data-mp="87q7ez0oyi83" />
      </Helmet>
      <div className="flex flex-col w-full min-h-screen bg-[#f8f6f2]" data-id="element-9971" data-mp="88i3sc244jzf">
        <header className="bg-white border-b border-gray-200" data-id="element-9972" data-mp="7uyxxmptp7px">
          <div className="max-w-4xl mx-auto px-5 py-4" data-id="element-9973" data-mp="cmgr3ollu40c">
            <Link to="/" className="inline-flex items-center text-gray-600 hover:text-purple-600 text-sm mb-2" data-id="element-9974" data-mp="co1jp8oczcvk">
              <ArrowLeft size={16} className="mr-1" data-id="element-9975" data-mp="2wfdjqqvo3zo" />
              Back to Home
            </Link>
            <h1 className="text-2xl font-bold" data-id="element-9976" data-mp="qm000jm8pjdp">Terms of Service</h1>
            <p className="text-gray-600 text-sm mt-1" data-id="element-9977" data-mp="qkow8jssobml">
              Last updated:{' '}
              {new Date().toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            })}
            </p>
          </div>
        </header>

        <div className="max-w-4xl mx-auto w-full px-5 py-8" data-id="element-9978" data-mp="32c27lu7j955f">
          <div className="bg-white rounded-xl p-8 shadow-sm" data-id="element-9979" data-mp="32ahfeb8oxyaq">
            <section className="mb-8" data-id="element-9980" data-mp="37bf65c7ro0nu">
              <h2 className="text-xl font-bold mb-4" data-id="element-9981" data-mp="37cgidk0iqt75">Agreement to Terms</h2>
              <p className="text-gray-700 mb-4" data-id="element-9982" data-mp="1ctvnyccju5sx">
                Welcome to ToxicDetector. These Terms of Service ("Terms")
                govern your access to and use of our website, application, and
                services (collectively, the "Services"). By accessing or using
                our Services, you agree to be bound by these Terms and our
                Privacy Policy.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-9983" data-mp="u58gjn6wh4c6">
                If you do not agree to these Terms, you may not access or use
                our Services. We reserve the right to modify these Terms at any
                time, and your continued use of the Services constitutes
                acceptance of any changes.
              </p>
              <p className="text-gray-700" data-id="element-9984" data-mp="g70mbn190h4p">
                <strong data-id="element-9985" data-mp="2ej95tdudupl9">IMPORTANT:</strong> These Terms contain an arbitration
                clause and class action waiver that affect your legal rights.
                Please read Section 14 carefully.
              </p>
            </section>

            <section className="mb-8" data-id="element-9986" data-mp="3sehhz40ssnvh">
              <h2 className="text-xl font-bold mb-4" data-id="element-9987" data-mp="197naz1uzlfj">
                1. Description of Services
              </h2>
              <p className="text-gray-700 mb-4" data-id="element-9988" data-mp="61sh40krlyj2">
                ToxicDetector is an AI-powered platform that analyzes text
                conversations for patterns of toxic behavior, including but not
                limited to gaslighting, manipulation, emotional abuse, and other
                harmful communication patterns. Our Services include:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-9989" data-mp="3ihmleqo34xju">
                <li data-id="element-9990" data-mp="3ikh1k602fw7g">Screenshot upload and secure storage</li>
                <li data-id="element-9991" data-mp="3niseiplnqmtw">
                  AI-powered toxicity analysis using advanced natural language
                  processing
                </li>
                <li data-id="element-9992" data-mp="12qq8r9x7xgc0">Detailed reports on detected patterns and risk levels</li>
                <li data-id="element-9993" data-mp="12sta2q3tmvw1">Scan history and result management</li>
                <li data-id="element-9994" data-mp="11am8a9douoft">Result sharing capabilities</li>
                <li data-id="element-9995" data-mp="waq4ob8wkz0s">User account management and privacy controls</li>
              </ul>
              <p className="text-gray-700" data-id="element-9996" data-mp="wd2u19gzqbnv">
                ToxicDetector is provided for informational and educational
                purposes only. Our analysis is not a substitute for professional
                advice from qualified mental health professionals, therapists,
                counselors, or legal advisors.
              </p>
            </section>

            <section className="mb-8" data-id="element-9997" data-mp="1f92pwvd39zcq">
              <h2 className="text-xl font-bold mb-4" data-id="element-9998" data-mp="1tyidy3l8jqoq">
                2. Eligibility and Account Registration
              </h2>

              <h3 className="text-lg font-semibold mb-3" data-id="element-9999" data-mp="1oz5fell04v6b">
                2.1 Age Requirements
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-10000" data-mp="23083t4zgyhke">
                You must be at least 18 years old to use ToxicDetector. By using
                our Services, you represent and warrant that you are at least 18
                years of age and have the legal capacity to enter into these
                Terms.
              </p>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10001" data-mp="2mk6xezs21uky">
                2.2 Account Creation
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-10002" data-mp="28njpy32h7m0s">
                To access certain features, you must create an account. You
                agree to:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-10003" data-mp="1ytt6xdp4c3sh">
                <li data-id="element-10004" data-mp="23n5tlia8m0il">
                  Provide accurate, current, and complete information during
                  registration
                </li>
                <li data-id="element-10005" data-mp="1ovdd32ypigfa">Maintain and promptly update your account information</li>
                <li data-id="element-10006" data-mp="1twkln48objn0">
                  Maintain the security of your password and account credentials
                </li>
                <li data-id="element-10007" data-mp="1fyw1xzqceijj">
                  Accept responsibility for all activities that occur under your
                  account
                </li>
                <li data-id="element-10008" data-mp="3mltxm8nhcezl">
                  Notify us immediately of any unauthorized access or security
                  breach
                </li>
              </ul>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10009" data-mp="3cupklehd747e">
                2.3 Account Security
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-10010" data-mp="38tx9efoxmp8h">
                You are solely responsible for maintaining the confidentiality
                of your account credentials. We strongly recommend enabling
                two-factor authentication (2FA) for enhanced security. You agree
                not to share your account with others or allow others to access
                your account.
              </p>
            </section>

            <section className="mb-8" data-id="element-10011" data-mp="3rjdcnas04vsl">
              <h2 className="text-xl font-bold mb-4" data-id="element-10012" data-mp="2l3t6kajkitij">
                3. Acceptable Use Policy
              </h2>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10013" data-mp="2g4zveorr7elj">3.1 Permitted Uses</h3>
              <p className="text-gray-700 mb-4" data-id="element-10014" data-mp="2g72oxis47pv0">
                You may use ToxicDetector only for lawful purposes and in
                accordance with these Terms. You agree to use the Services only
                to analyze conversations to which you are a party or for which
                you have obtained proper consent.
              </p>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10015" data-mp="19evqgcpuplgn">
                3.2 Prohibited Uses
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-10016" data-mp="1ecnfmyz42th5">You agree NOT to:</p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-10017" data-mp="1jbguovu1qsjf">
                <li data-id="element-10018" data-mp="1obmghvdmxktl">
                  Upload conversations or content that you do not have the right
                  to analyze
                </li>
                <li data-id="element-10019" data-mp="1sceqwry8tvrg">
                  Violate any applicable laws, regulations, or third-party
                  rights
                </li>
                <li data-id="element-10020" data-mp="3u4b92kex23v7">
                  Upload content containing child exploitation material, illegal
                  content, or content that violates others' privacy
                </li>
                <li data-id="element-10021" data-mp="368zkqfuuo7oc">
                  Use the Services to harass, abuse, stalk, threaten, or
                  intimidate others
                </li>
                <li data-id="element-10022" data-mp="3jz31irayn96e">
                  Attempt to gain unauthorized access to our systems or other
                  users' accounts
                </li>
                <li data-id="element-10023" data-mp="2s96zv1608loa">
                  Reverse engineer, decompile, or attempt to extract source code
                  from our Services
                </li>
                <li data-id="element-10024" data-mp="2nbonf0ss3obj">
                  Use automated systems (bots, scrapers) to access the Services
                  without permission
                </li>
                <li data-id="element-10025" data-mp="2waaczfwo43lt">Interfere with or disrupt the Services or servers</li>
                <li data-id="element-10026" data-mp="gjnulyxvpfph">
                  Impersonate any person or entity or misrepresent your
                  affiliation
                </li>
                <li data-id="element-10027" data-mp="bjje48wz0kz9">
                  Use the Services for any commercial purpose without our
                  written consent
                </li>
                <li data-id="element-10028" data-mp="k3xz27knlhn3">Remove, obscure, or alter any legal notices or branding</li>
              </ul>
            </section>

            <section className="mb-8" data-id="element-10029" data-mp="a3nq4z5niwdq">
              <h2 className="text-xl font-bold mb-4" data-id="element-10030" data-mp="a4yqsq3svo0m">
                4. User Content and Consent
              </h2>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10031" data-mp="f2qra8iigigf">4.1 Your Content</h3>
              <p className="text-gray-700 mb-4" data-id="element-10032" data-mp="12te6zfyo4cdj">
                You retain all ownership rights to the content you upload ("User
                Content"). By uploading content to ToxicDetector, you represent
                and warrant that:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-10033" data-mp="y0tcec7xtv8y">
                <li data-id="element-10034" data-mp="xz07b1cz3j32">
                  You own or have the necessary rights to upload and analyze the
                  content
                </li>
                <li data-id="element-10035" data-mp="1qip5srwgjwp1">
                  The content does not violate any laws or third-party rights
                </li>
                <li data-id="element-10036" data-mp="1shlljra4jm2v">
                  You have obtained all necessary consents from other parties in
                  the conversation
                </li>
                <li data-id="element-10037" data-mp="1jgx6ct8zvfoe">
                  The content does not contain illegal material or violate our
                  Acceptable Use Policy
                </li>
              </ul>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10038" data-mp="19qkios5vv6e1">4.2 License Grant</h3>
              <p className="text-gray-700 mb-4" data-id="element-10039" data-mp="19ohorx1m0t41">
                By uploading User Content, you grant ToxicDetector a limited,
                non-exclusive, worldwide, royalty-free license to:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-10040" data-mp="14rhfld9gra8p">
                <li data-id="element-10041" data-mp="14rr9vd1jk3k7">Store and process your content to provide the Services</li>
                <li data-id="element-10042" data-mp="qt1bzv6wdzus">Perform AI analysis on your content</li>
                <li data-id="element-10043" data-mp="vrcj3y5t5w9b">Display analysis results to you</li>
                <li data-id="element-10044" data-mp="vq1drtwpsgg3">
                  Create aggregated, anonymized data for service improvement (no
                  personal identifiers)
                </li>
              </ul>
              <p className="text-gray-700 mb-4" data-id="element-10045" data-mp="77806tufd8tu">
                This license terminates when you delete your content or account,
                except for content you have chosen to share publicly.
              </p>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10046" data-mp="h2t1sqvl0732">
                4.3 Content Removal
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-10047" data-mp="v1ivrxn3tqn7">
                We reserve the right to remove any User Content that violates
                these Terms, our policies, or applicable law. We may also
                suspend or terminate accounts that repeatedly violate our
                policies.
              </p>
            </section>

            <section className="mb-8" data-id="element-10048" data-mp="1dtlj1ru9456f">
              <h2 className="text-xl font-bold mb-4" data-id="element-10049" data-mp="1dums5qrpihli">
                5. Intellectual Property Rights
              </h2>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10050" data-mp="19qynbfugm03y">
                5.1 Our Intellectual Property
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-10051" data-mp="1lujc7i7kni88">
                ToxicDetector and all associated content, features,
                functionality, software, algorithms, designs, logos, and
                trademarks are owned by ToxicDetector and are protected by
                copyright, trademark, patent, and other intellectual property
                laws.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-10052" data-mp="24lk8tzl7z1om">
                <strong data-id="element-10053" data-mp="24k99qd2pyi3u">
                  © {new Date().getFullYear()} ToxicDetector. All rights
                  reserved.
                </strong>
              </p>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10054" data-mp="2ek9qpsd48m4v">
                5.2 Limited License
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-10055" data-mp="f7nvjj5fpzlm">
                Subject to these Terms, we grant you a limited, non-exclusive,
                non-transferable, revocable license to access and use the
                Services for your personal, non-commercial use. This license
                does not include any right to:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-10056" data-mp="2sn5s0l7133jz">
                <li data-id="element-10057" data-mp="2oo6nv2t4fatl">Resell or make commercial use of the Services</li>
                <li data-id="element-10058" data-mp="2jpdbjdpklpv0">Modify, copy, or create derivative works</li>
                <li data-id="element-10059" data-mp="3geuomdqvue6q">
                  Download or extract any portion of the Services (except as
                  expressly permitted)
                </li>
                <li data-id="element-10060" data-mp="3cdr9jtgnsm6k">
                  Use any data mining, robots, or similar data gathering tools
                </li>
              </ul>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10061" data-mp="32f22kvqawm53">5.3 Feedback</h3>
              <p className="text-gray-700 mb-4" data-id="element-10062" data-mp="32etqv75wzmvh">
                If you provide feedback, suggestions, or ideas about our
                Services, you grant us the right to use such feedback without
                compensation or attribution.
              </p>
            </section>

            <section className="mb-8" data-id="element-10063" data-mp="3ev1hzbk6ojvi">
              <h2 className="text-xl font-bold mb-4" data-id="element-10064" data-mp="3jnb1o9upgnpc">
                6. AI Analysis and Accuracy
              </h2>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10065" data-mp="35wg1rn26pgxw">
                6.1 Nature of AI Analysis
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-10066" data-mp="3aw2gk0xnv58t">
                Our toxicity analysis is powered by artificial intelligence and
                machine learning algorithms. While we strive for accuracy, AI
                analysis has inherent limitations and may not always be 100%
                accurate or complete.
              </p>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10067" data-mp="3ooi9g8wulmw0">6.2 No Guarantees</h3>
              <p className="text-gray-700 mb-4" data-id="element-10068" data-mp="3tjxo332ojmth">
                We do not guarantee that our analysis will:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-10069" data-mp="2d9ll718hn1pp">
                <li data-id="element-10070" data-mp="2i7wqqzrr2q24">Detect all instances of toxic behavior</li>
                <li data-id="element-10071" data-mp="2am1evlb7n21p">Be free from false positives or false negatives</li>
                <li data-id="element-10072" data-mp="25nq3351cuhgu">
                  Account for context, sarcasm, cultural differences, or nuanced
                  communication
                </li>
                <li data-id="element-10073" data-mp="2jmz8d9o0vr61">
                  Provide legally admissible evidence or professional
                  psychological assessment
                </li>
              </ul>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10074" data-mp="1qy24ibkk5wwt">
                6.3 Not Professional Advice
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-10075" data-mp="1myjjzgwnfnui">
                <strong data-id="element-10076" data-mp="20od5pqcuxs00">IMPORTANT:</strong> ToxicDetector's analysis is for
                informational purposes only and does not constitute professional
                advice. Our Services are not a substitute for:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-10077" data-mp="187am6kilew6a">
                <li data-id="element-10078" data-mp="139smlkqgttay">Mental health counseling or therapy</li>
                <li data-id="element-10079" data-mp="1376d3fk0l3q3">Legal advice or representation</li>
                <li data-id="element-10080" data-mp="33ah19gj9i8uz">Medical diagnosis or treatment</li>
                <li data-id="element-10081" data-mp="339nzyv32obk8">Professional relationship counseling</li>
              </ul>
              <p className="text-gray-700 mb-4" data-id="element-10082" data-mp="388qzk00a9pkt">
                If you are experiencing abuse, harassment, or mental health
                concerns, please seek help from qualified professionals, law
                enforcement, or support organizations.
              </p>
            </section>

            <section className="mb-8" data-id="element-10083" data-mp="2keh3tq7imd40">
              <h2 className="text-xl font-bold mb-4" data-id="element-10084" data-mp="2pbh9w14d7fv4">
                7. Privacy and Data Protection
              </h2>
              <p className="text-gray-700 mb-4" data-id="element-10085" data-mp="2uakg3ow2zs4o">
                Your privacy is important to us. Our collection, use, and
                protection of your personal information is governed by our
                Privacy Policy, which is incorporated into these Terms by
                reference. By using our Services, you consent to our Privacy
                Policy.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-10086" data-mp="1y4qygt558gpg">Key privacy points:</p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-10087" data-mp="1u2m4tuep3k2t">
                <li data-id="element-10088" data-mp="1u3fbywhkgblh">We encrypt all data in transit and at rest</li>
                <li data-id="element-10089" data-mp="1pavrrgodii7p">You control your data retention settings</li>
                <li data-id="element-10090" data-mp="1kd2k0j7f9g5b">You can delete your data at any time</li>
                <li data-id="element-10091" data-mp="1kckh53q983of">We do not sell your personal information</li>
                <li data-id="element-10092" data-mp="1fesou8lp6fjp">
                  We comply with GDPR, CCPA, and other privacy regulations
                </li>
              </ul>
            </section>

            <section className="mb-8" data-id="element-10093" data-mp="1agzh3b4qxdhb">
              <h2 className="text-xl font-bold mb-4" data-id="element-10094" data-mp="16c9r22wrqt4b">
                8. Disclaimers and Limitations of Liability
              </h2>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10095" data-mp="11fsymwijdslf">
                8.1 Service Provided "As Is"
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-10096" data-mp="30oq2di4f8xg1">
                THE SERVICES ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS
                WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED,
                INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY,
                FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, OR ACCURACY.
              </p>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10097" data-mp="1uwk9dmzirkg8">8.2 No Warranty</h3>
              <p className="text-gray-700 mb-4" data-id="element-10098" data-mp="1zulzgrvd4k17">We do not warrant that:</p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-10099" data-mp="1lvw35egdaodw">
                <li data-id="element-10100" data-mp="1pxhciptp0kjc">
                  The Services will be uninterrupted, timely, secure, or
                  error-free
                </li>
                <li data-id="element-10101" data-mp="1bz9ioqrydzce">
                  The results obtained from using the Services will be accurate
                  or reliable
                </li>
                <li data-id="element-10102" data-mp="36bzbt6ahz4iq">Any errors in the Services will be corrected</li>
                <li data-id="element-10103" data-mp="36csg80lzhhxp">The Services will meet your specific requirements</li>
              </ul>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10104" data-mp="3baanzno9lr44">
                8.3 Limitation of Liability
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-10105" data-mp="zldvyott1y0m">
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, TOXICDETECTOR SHALL NOT
                BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL,
                OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER
                INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE,
                GOODWILL, OR OTHER INTANGIBLE LOSSES RESULTING FROM:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-10106" data-mp="1de3n17o6xt4l">
                <li data-id="element-10107" data-mp="1scxl0pd326aj">Your use or inability to use the Services</li>
                <li data-id="element-10108" data-mp="1sa1on5gvvpo7">
                  Any unauthorized access to or use of our servers and/or any
                  personal information stored therein
                </li>
                <li data-id="element-10109" data-mp="3u4anl7rkw23f">
                  Any interruption or cessation of transmission to or from the
                  Services
                </li>
                <li data-id="element-10110" data-mp="1m4c36vavzszh">
                  Any bugs, viruses, or similar issues transmitted through the
                  Services
                </li>
                <li data-id="element-10111" data-mp="1h4ze03wjm9tq">
                  Any errors or omissions in any content or for any loss or
                  damage incurred as a result of the use of any content posted,
                  emailed, transmitted, or otherwise made available through the
                  Services
                </li>
                <li data-id="element-10112" data-mp="135zqx0ooi2zo">
                  The accuracy or reliability of any AI analysis or results
                </li>
              </ul>
              <p className="text-gray-700 mb-4" data-id="element-10113" data-mp="1d3xedlyprvr8">
                IN NO EVENT SHALL OUR TOTAL LIABILITY TO YOU FOR ALL DAMAGES,
                LOSSES, AND CAUSES OF ACTION EXCEED THE AMOUNT PAID BY YOU, IF
                ANY, FOR ACCESSING THE SERVICES IN THE TWELVE (12) MONTHS PRIOR
                TO THE CLAIM, OR ONE HUNDRED DOLLARS ($100), WHICHEVER IS
                GREATER.
              </p>
            </section>

            <section className="mb-8" data-id="element-10114" data-mp="2r38wpuwtn978">
              <h2 className="text-xl font-bold mb-4" data-id="element-10115" data-mp="2r27b4wi6j4b9">9. Indemnification</h2>
              <p className="text-gray-700 mb-4" data-id="element-10116" data-mp="2w3ei4tchzzgv">
                You agree to indemnify, defend, and hold harmless ToxicDetector,
                its officers, directors, employees, agents, and affiliates from
                and against any claims, liabilities, damages, losses, costs,
                expenses, or fees (including reasonable attorneys' fees) arising
                from:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-10117" data-mp="3esl4cqci397f">
                <li data-id="element-10118" data-mp="312hn6dsha5ou">Your use or misuse of the Services</li>
                <li data-id="element-10119" data-mp="30zveubxrjm5k">Your violation of these Terms</li>
                <li data-id="element-10120" data-mp="351yu7bnjzaw4">Your violation of any rights of another party</li>
                <li data-id="element-10121" data-mp="3sscegfzwc5g5">Your User Content</li>
                <li data-id="element-10122" data-mp="3srb3scmslkyy">Your violation of any applicable laws or regulations</li>
              </ul>
            </section>

            <section className="mb-8" data-id="element-10123" data-mp="1gb1nmuj5tfx">
              <h2 className="text-xl font-bold mb-4" data-id="element-10124" data-mp="baow67f6pumw">10. Termination</h2>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10125" data-mp="78lkpisimq1m">
                10.1 Termination by You
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-10126" data-mp="298poarhqcny">
                You may terminate your account at any time by accessing your
                Settings and selecting the account deletion option. Upon
                termination, your access to the Services will cease immediately.
              </p>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10127" data-mp="3jq8kcs100mv3">
                10.2 Termination by Us
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-10128" data-mp="3fnlsws88p3yf">
                We reserve the right to suspend or terminate your account and
                access to the Services at any time, with or without notice, for
                any reason, including but not limited to:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-10129" data-mp="30re4ffpstgdc">
                <li data-id="element-10130" data-mp="30tgxy9q5trmt">Violation of these Terms or our policies</li>
                <li data-id="element-10131" data-mp="2qmo0x5eqy470">Fraudulent, abusive, or illegal activity</li>
                <li data-id="element-10132" data-mp="2vlr56nmwk6dx">Extended periods of inactivity</li>
                <li data-id="element-10133" data-mp="2voddiphmapx7">Technical or security reasons</li>
                <li data-id="element-10134" data-mp="30l3qh3y4l5ee">At our sole discretion</li>
              </ul>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10135" data-mp="35kgdboozycgz">
                10.3 Effect of Termination
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-10136" data-mp="27x7y2bfl9znf">Upon termination:</p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-10137" data-mp="27uv8pd7i4n0c">
                <li data-id="element-10138" data-mp="2cw2ex7tzxe4w">Your right to use the Services will immediately cease</li>
                <li data-id="element-10139" data-mp="2hu3z5w35rjhy">
                  We will delete your account data according to our data
                  retention policy
                </li>
                <li data-id="element-10140" data-mp="1p6838tlexvm8">
                  Provisions that by their nature should survive termination
                  will remain in effect
                </li>
                <li data-id="element-10141" data-mp="1u3qi10m43525">
                  You remain liable for any obligations incurred prior to
                  termination
                </li>
              </ul>
            </section>

            <section className="mb-8" data-id="element-10142" data-mp="3qwp3dn90ubf6">
              <h2 className="text-xl font-bold mb-4" data-id="element-10143" data-mp="3qtjd44onp3hv">
                11. Third-Party Services and Links
              </h2>
              <p className="text-gray-700 mb-4" data-id="element-10144" data-mp="4ofqgqgao066">
                Our Services may contain links to third-party websites,
                services, or resources. We do not endorse and are not
                responsible for:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-10145" data-mp="edfs6hm6l9o2">
                <li data-id="element-10146" data-mp="se0cxjbnpfk7">
                  The availability, accuracy, or content of third-party services
                </li>
                <li data-id="element-10147" data-mp="nf6x3k8wdcgv">Third-party privacy practices or terms of service</li>
                <li data-id="element-10148" data-mp="2u4bt513or2g2">Any damages or losses caused by third-party services</li>
              </ul>
              <p className="text-gray-700 mb-4" data-id="element-10149" data-mp="2p6tsdxztntj5">
                Your interactions with third-party services are solely between
                you and the third party. We encourage you to review the terms
                and privacy policies of any third-party services you access.
              </p>
            </section>

            <section className="mb-8" data-id="element-10150" data-mp="uxevf90e0oo7">
              <h2 className="text-xl font-bold mb-4" data-id="element-10151" data-mp="uwc26uflea54">
                12. Modifications to Services and Terms
              </h2>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10152" data-mp="lwyqdv3zx9h8">
                12.1 Service Changes
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-10153" data-mp="qxmhegs85qbg">
                We reserve the right to modify, suspend, or discontinue any
                aspect of the Services at any time, with or without notice. We
                are not liable to you or any third party for any modification,
                suspension, or discontinuation of the Services.
              </p>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10154" data-mp="2bc6c4oo687ho">12.2 Terms Changes</h3>
              <p className="text-gray-700 mb-4" data-id="element-10155" data-mp="2ba2ayehnpml3">
                We may revise these Terms at any time. Material changes will be
                notified through:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-10156" data-mp="24uv15hb462b4">
                <li data-id="element-10157" data-mp="1zxuvv8m393l2">Email notification to your registered email address</li>
                <li data-id="element-10158" data-mp="1vvzu6308wo6r">Prominent notice on our website or application</li>
                <li data-id="element-10159" data-mp="1vxuf3hbiogau">Updated "Last Updated" date at the top of these Terms</li>
              </ul>
              <p className="text-gray-700 mb-4" data-id="element-10160" data-mp="2snlbjm3dcdja">
                Your continued use of the Services after changes become
                effective constitutes acceptance of the revised Terms. If you do
                not agree to the changes, you must stop using the Services and
                delete your account.
              </p>
            </section>

            <section className="mb-8" data-id="element-10161" data-mp="3bd1pbb42e2hn">
              <h2 className="text-xl font-bold mb-4" data-id="element-10162" data-mp="3be34nrs45b56">
                13. Governing Law and Jurisdiction
              </h2>
              <p className="text-gray-700 mb-4" data-id="element-10163" data-mp="t3fa6sjuf22d">
                These Terms shall be governed by and construed in accordance
                with the laws of the United States, without regard to its
                conflict of law provisions.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-10164" data-mp="125ol3jj0wxga">
                You agree to submit to the personal and exclusive jurisdiction
                of the courts located within the United States for the
                resolution of any disputes arising from these Terms or your use
                of the Services.
              </p>
            </section>

            <section className="mb-8" data-id="element-10165" data-mp="1lrb45pi12fvg">
              <h2 className="text-xl font-bold mb-4" data-id="element-10166" data-mp="1lscoylouigqd">
                14. Dispute Resolution and Arbitration
              </h2>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10167" data-mp="1us9704gqchcg">
                14.1 Informal Resolution
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-10168" data-mp="1zqsy0ja6kjbo">
                Before filing a claim, you agree to contact us at
                toxicdetector25@gmail.com to attempt to resolve the dispute
                informally. We will attempt to resolve the dispute within 60
                days.
              </p>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10169" data-mp="1jp50511wcd7r">
                14.2 Binding Arbitration
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-10170" data-mp="1fol1tu5l73k1">
                If we cannot resolve the dispute informally, any dispute arising
                from these Terms or the Services shall be resolved through
                binding arbitration in accordance with the American Arbitration
                Association's rules, except as modified by these Terms.
              </p>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10171" data-mp="vz0uko55e3e4">
                14.3 Class Action Waiver
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-10172" data-mp="88dl3yfl35pg">
                <strong data-id="element-10173" data-mp="4835rv5wj2xx">
                  YOU AND TOXICDETECTOR AGREE THAT EACH MAY BRING CLAIMS AGAINST
                  THE OTHER ONLY IN YOUR OR ITS INDIVIDUAL CAPACITY AND NOT AS A
                  PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS OR
                  REPRESENTATIVE PROCEEDING.
                </strong>
              </p>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10174" data-mp="3gcfonqdx75mf">14.4 Exceptions</h3>
              <p className="text-gray-700 mb-4" data-id="element-10175" data-mp="3l9xx7fo0zitw">
                Either party may seek injunctive or other equitable relief in
                any court of competent jurisdiction to prevent actual or
                threatened infringement, misappropriation, or violation of
                intellectual property rights.
              </p>
            </section>

            <section className="mb-8" data-id="element-10176" data-mp="2ykpgrq2rwuf">
              <h2 className="text-xl font-bold mb-4" data-id="element-10177" data-mp="7uru8h6qj2as">15. General Provisions</h2>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10178" data-mp="2nmyx0uy4jsr9">
                15.1 Entire Agreement
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-10179" data-mp="2smbl1j0qf5vf">
                These Terms, together with our Privacy Policy, constitute the
                entire agreement between you and ToxicDetector regarding the
                Services and supersede all prior agreements and understandings.
              </p>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10180" data-mp="1z5y5beq687rf">15.2 Severability</h3>
              <p className="text-gray-700 mb-4" data-id="element-10181" data-mp="2452ew6h0c7ia">
                If any provision of these Terms is found to be invalid or
                unenforceable, the remaining provisions will remain in full
                force and effect.
              </p>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10182" data-mp="1bh6i71rfufli">15.3 Waiver</h3>
              <p className="text-gray-700 mb-4" data-id="element-10183" data-mp="1gfgitrvxm8ei">
                Our failure to enforce any right or provision of these Terms
                will not be deemed a waiver of such right or provision.
              </p>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10184" data-mp="nq9j4pkqrcro">15.4 Assignment</h3>
              <p className="text-gray-700 mb-4" data-id="element-10185" data-mp="spdpl8ga6web">
                You may not assign or transfer these Terms or your rights
                hereunder without our prior written consent. We may assign these
                Terms without restriction.
              </p>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10186" data-mp="b8gm8rhztu85">15.5 Force Majeure</h3>
              <p className="text-gray-700 mb-4" data-id="element-10187" data-mp="bajm038y71q2">
                We shall not be liable for any failure or delay in performance
                due to circumstances beyond our reasonable control, including
                acts of God, war, terrorism, riots, natural disasters, or
                government actions.
              </p>

              <h3 className="text-lg font-semibold mb-3" data-id="element-10188" data-mp="3on3eoubyqon9">15.6 No Agency</h3>
              <p className="text-gray-700 mb-4" data-id="element-10189" data-mp="3ol0exil0dh5c">
                No agency, partnership, joint venture, or employment
                relationship is created between you and ToxicDetector as a
                result of these Terms or your use of the Services.
              </p>
            </section>

            <section className="mb-8" data-id="element-10190" data-mp="3apy4qj94p5mq">
              <h2 className="text-xl font-bold mb-4" data-id="element-10191" data-mp="302724kqjmdk5">
                16. Contact Information
              </h2>
              <p className="text-gray-700 mb-4" data-id="element-10192" data-mp="352cpvptozfwy">
                If you have questions about these Terms, please contact us:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-10193" data-mp="2r44xzwbij4sn">
                <p className="text-gray-700 mb-2" data-id="element-10194" data-mp="2w1ob2swh5bj0">
                  <strong data-id="element-10195" data-mp="3jqfzraauvbr1">Email:</strong> toxicdetector25@gmail.com
                </p>
                <p className="text-gray-700 mb-2" data-id="element-10196" data-mp="3jstrpaa8o7ud">
                  <strong data-id="element-10197" data-mp="3nqzvc9fs67b2">Support:</strong> support@toxicdetector.com
                </p>
                <p className="text-gray-700" data-id="element-10198" data-mp="3a1fsl3m79a1r">
                  <strong data-id="element-10199" data-mp="39yjwlktwwvfy">General Inquiries:</strong> toxicdetector25@gmail.com
                </p>
              </div>
            </section>

            <section className="mb-8 bg-red-50 p-6 rounded-xl border border-red-100" data-id="element-10200" data-mp="6je4rl0c7opy">
              <h2 className="text-xl font-bold mb-4 text-red-900" data-id="element-10201" data-mp="bae38up3ueuk">
                17. Liability & Usage Disclosure (Safe-Scalability)
              </h2>
              <p className="text-gray-800 mb-4" data-id="element-10202" data-mp="knwkchzzrp6e">
                ToxicDetector.ai is an AI-powered linguistic analysis tool
                designed for educational, entertainment, and self-validation
                purposes only.
              </p>
              <ul className="list-disc pl-6 text-gray-800 mb-4 space-y-2" data-id="element-10203" data-mp="pfo4a9on6wnk">
                <li data-id="element-10204" data-mp="piiqo6r7urjm">
                  <strong data-id="element-10205" data-mp="1q269pk0anh5">Not Clinical Advice:</strong> While our algorithms are
                  trained on behavioral patterns, ToxicDetector does not provide
                  medical, psychological, or psychiatric diagnoses. It is not a
                  substitute for professional therapy or mental health
                  counseling.
                </li>
                <li data-id="element-10206" data-mp="6rrj9aqshb7v">
                  <strong data-id="element-10207" data-mp="1n3y7gs05zqg9">Not Legal Evidence:</strong> The "Forensic Dossier"
                  and "Toxicity Scores" are digital interpretations of text
                  patterns and are not certified for use as primary evidence in
                  legal proceedings or divorce litigation.
                </li>
                <li data-id="element-10208" data-mp="3srz0ahc8axql">
                  <strong data-id="element-10209" data-mp="3sta0y8adnpdh">Data Privacy:</strong> We utilize AES-256 encryption.
                  By using this tool, you confirm you have the right to analyze
                  the uploaded text. ToxicDetector is not responsible for
                  interpersonal outcomes resulting from the use of our reports.
                </li>
                <li data-id="element-10210" data-mp="amc70y60r13p">
                  <strong data-id="element-10211" data-mp="akripqaaseea">Accuracy:</strong> AI is a pattern-recognition tool.
                  Results are probabilistic, not absolute truths.
                </li>
              </ul>
            </section>

            <section className="mb-8 bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-10212" data-mp="pbich3vg9nk1">
              <h2 className="text-xl font-bold mb-4" data-id="element-10213" data-mp="pdb8lp8fspds">
                18. Refund Policy: Digital Forensic Scans
              </h2>
              <p className="text-gray-800 font-semibold mb-2" data-id="element-10214" data-mp="ybnainer79lj">
                Final Sale Notice: Due to the immediate nature of AI-driven
                linguistic analysis, all completed scans are Final and
                Non-Refundable.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-10215" data-mp="2dx8s9st0ldyf">
                Once the Forensic Engine processes your data and generates your
                Toxicity Score, the digital value—derived from our proprietary
                algorithms and server processing—has been fully delivered. We do
                not offer refunds based on the 'result' of a scan (e.g., if you
                disagree with a 'Saint' or 'Toxic' rating), as the AI provides
                an objective analysis based on the text provided.
              </p>
              <p className="text-gray-700" data-id="element-10216" data-mp="2nttwwd14gn1q">
                If you experience a technical error where a report is not
                generated, please contact Support@ToxicDetector.com for a manual
                re-run.
              </p>
            </section>

            <section className="mb-8" data-id="element-10217" data-mp="3gfwjttks7ema">
              <h2 className="text-xl font-bold mb-4" data-id="element-10218" data-mp="38byz7siuitr">19. Acknowledgment</h2>
              <p className="text-gray-700 mb-4" data-id="element-10219" data-mp="87x82b1eo7k7">
                BY USING TOXICDETECTOR, YOU ACKNOWLEDGE THAT YOU HAVE READ THESE
                TERMS OF SERVICE, UNDERSTAND THEM, AND AGREE TO BE BOUND BY
                THEM. IF YOU DO NOT AGREE TO THESE TERMS, YOU MUST NOT USE OUR
                SERVICES.
              </p>
            </section>

            <div className="border-t border-gray-200 pt-6 mt-8" data-id="element-10220" data-mp="3gmyujjhsftd3">
              <p className="text-gray-600 text-sm text-center" data-id="element-10221" data-mp="3lncq4227dau8">
                © {new Date().getFullYear()} ToxicDetector. All rights
                reserved.
              </p>
              <p className="text-gray-500 text-xs text-center mt-2" data-id="element-10222" data-mp="3bonir37xn8s8">
                These Terms of Service were last updated on{' '}
                {new Date().toLocaleDateString('en-US', {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
              })}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>;
}